import { useQuery } from 'react-query';
import getMe from 'data/requests/getMe';
import { Me } from 'model/me';
import { getToken } from 'utils/storage';

const useMe = () => {
  const { data, isLoading, isFetching } = useQuery<Me>('me', getMe, {
    staleTime: 1000 * 60 * 5,
    enabled: getToken() !== '',
  });

  return { me: data, isLoading, isFetching };
};

export default useMe;
